import React, { useState, useEffect } from 'react';
import Storage from 'src/utils/storage/storage';
import { Skeleton, Stack } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../hooks';
import { getFavoriteList } from '../../../store/landing-slice';
import './section.scss';
import PageListComponent from './page-list-component';

export default function FavoritesListComponent() {
  const appDispatch = useAppDispatch();

  // getting the favorite list from store
  const { isFavoriteListFetching, favouriteListData: favouriteList } =
    useAppSelector((state) => state.landing);

  // getting the source id from storage
  const { source: sourceId } = Storage.getSourceId();

  // useeffect for getting the favorite list
  useEffect(() => {
    if(sourceId){
      appDispatch(getFavoriteList({ sourceId }));
    }
  }, [sourceId]);

  // loading skeleton
  const loadingSkeleton = () => {
    const a = [1, 1, 1, 1];
    return (
      <>
        {a.map((e) => (
          <Stack spacing={1} margin={1}>
            <Skeleton
              animation='wave'
              variant='rectangular'
              width='100%'
              height={30}
            />
          </Stack>
        ))}
      </>
    );
  };

  return (
    <>
      {isFavoriteListFetching ? (
        loadingSkeleton()
      ) : favouriteList?.data?.length > 0 ? (
        // calling page list component
        <PageListComponent
          pageList={favouriteList.data}
          sectionType='favorite'
          identifierMap={favouriteList.identifier}
        />
      ) : (
        <div className='info-text-msg'>Your Favorites will appear here</div>
      )}
    </>
  );
}
